import styled, { css } from 'styled-components';
import { colors } from 'global/colors';

export const InformationBox = styled.div`
  display: block;
  padding: 10px;
  line-height: 30px;
  font-size: 14px;
  color: ${colors.lightBlue4};
  background-color: ${colors.lightBlue3};
  border-color: ${colors.lightBlue5} !important;
  border: 1px solid transparent;
  border-radius: 0.25rem;

  ${(props) =>
    props.warning &&
    css`
      color: ${colors.lightBrown};
      background-color: ${colors.lightYellow};
      border-color: ${colors.lightYellow2} !important;
    `}

  ${(props) =>
    props.danger &&
    css`
      color: ${colors.lightRed3};
      background-color: ${colors.lightRed};
      border-color: ${colors.lightRed2} !important;
    `}

  ${(props) =>
    props.textCenter &&
    css`
      text-align: center;
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const BodyContainer = styled.div`
  margin-top: 20px;
  font-size: 14px;
`;

export const CategoryContainer = styled.div`
  margin-top: 2rem;
  margin-bottom: 2rem;
`;

export const CategoryNameAndInstructionsContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const CategoryName = styled.div`
  font-weight: bold;
  font-size: 14px;
`;

export const TestInformationContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);

  ${(props) =>
    props.isRepeatedTicket &&
    css`
      grid-template-columns: 1fr 2fr 1fr;
    `}
`;

export const Information = styled.div`
  text-align: ${(props) => (props.textAlign ? props.textAlign : 'center')};
`;

export const FinishedLabel = styled.div`
  text-align: center;
  font-weight: 700;
`;

export const OldReportButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const ScoreContainer = styled.div``;

export const ScoreAndButtonContainer = styled.div`
  display: flex;
  justify-content: end;
`;

export const CompanyLogo = styled.img`
  height: 50px;
`;
